import { createAction } from "redux-actions";
import { loadFaqList as loadFaqListApi } from "../../services/faq";

export enum ACTIONS {
	LOAD_FAQ_LIST = "FAQ/LOAD_FAQ_LIST",
	SET_MODAL_CONTENT = "FAQ/SET_MODAL_CONTENT",
}

export const loadFaqList = createAction(ACTIONS.LOAD_FAQ_LIST, loadFaqListApi);
export const setModalContent = createAction(ACTIONS.SET_MODAL_CONTENT);
